import React, { useEffect } from 'react';
import { TimeRangePickerFieldSC } from './time-range-picker-field.styled';
import { useFieldData } from '../../reservation-form.utils';
import { RangePickerDeprecated } from '../../../../../../components/ui';
import moment from 'moment';
import TStore from '../../../../../../types/store';
import { connect } from 'react-redux';
import { generateDisabledTimes } from '../../../calendar-edit/components/add-form/add-form.util';
import { isAfter } from 'date-fns';
import { bindActionCreators } from 'redux';
import ClockIcon from '../../../../../../assets/svg/e-calendar/clock.svg';
import { useIntl } from 'react-intl';
import { actions } from '../../../../../../store/ducks/reservation-form-slice';
import { FormField } from '@hilbi/web-common/components/hilbi-form';

type DescriptionFieldProps = {
  name: string;
  placeHolder?: string;
  disabled: boolean;
} & ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

const TimeRangePickerField: React.FunctionComponent<DescriptionFieldProps> = ({
  name,
  event,
  updateEditedEventPosition,
  disabled,
}) => {
  const { formatMessage } = useIntl();
  const { value, setValue, error } = useFieldData(name);
  const disabledTimes = React.useMemo(() => {
    return generateDisabledTimes({
      start: new Date(event.start),
      minTime: event.minTime ? new Date(event.minTime) : undefined,
      maxTime: event.maxTime ? new Date(event.maxTime) : undefined,
    });
  }, [event.start, event.maxTime, event.minTime]);

  useEffect(() => {
    updateEditedEventPosition({
      from: value.fromTime,
      to: value.toTime,
    });
  }, [value, updateEditedEventPosition]);

  return (
    <TimeRangePickerFieldSC>
      <FormField
        disabled={disabled}
        error={error ? formatMessage({ id: error }) : ''}
        icon={ClockIcon}
      >
        <RangePickerDeprecated
          disabled={disabled}
          picker="time"
          generateConfig="moment"
          showSecond={false}
          showNow={false}
          format="HH:mm"
          kind="bubble"
          disabledHours={disabledTimes.disabledHours}
          disabledMinutes={disabledTimes.disabledMinutes}
          value={[moment(value.fromTime), moment(value.toTime)]}
          onChange={(dates) => {
            let fromTime = dates?.[0] ? dates?.[0]?.toISOString() : value.fromTime;
            let toTime = dates?.[1] ? dates?.[1]?.toISOString() : value.toTime;

            if (!fromTime || !toTime) {
              return;
            }

            fromTime = event.minTime
              ? isAfter(dates![0]!.toDate(), new Date(event.minTime))
                ? fromTime!
                : event.minTime
              : fromTime!;

            toTime = event.maxTime
              ? isAfter(dates![1]!.toDate(), new Date(event.maxTime))
                ? event.maxTime
                : toTime!
              : toTime!;

            setValue({
              fromTime,
              toTime,
            });
          }}
          minuteStep={15}
          hideDisabledOptions
        />
      </FormField>
    </TimeRangePickerFieldSC>
  );
};

const mapStateToProps = (state: TStore) => ({
  event: state.reservationForm.event,
});

const mapDispatchToProps = (dispatch: any) => {
  return {
    ...bindActionCreators(
      {
        updateEditedEventPosition: actions.updateEditedEventPosition,
      },
      dispatch,
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(TimeRangePickerField));
